import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Screen } from '../../components/Screen/Screen';
import { ScreenHeader } from '../../components/ScreenHeader/ScreenHeader';
import { ProgressIndicator } from '../../components/ProgressIndicator/ProgressIndicator';
import { Button } from '../../components/Button/Button';
import { TextInput } from '../../components/TextInput/TextInput';
import { copy } from '../../constants';
import { useOnboardingStore } from '../../store/onboarding';

export const OptionalNote: React.FC = () => {
  const navigate = useNavigate();
  const { data, updateData, setStep } = useOnboardingStore();

  const note = data.optional_note || '';

  const handleSkip = () => {
    updateData({ optional_note: '' });
    setStep(6);
    navigate('/occupation');
  };

  const handleContinue = () => {
    setStep(6);
    navigate('/occupation');
  };

  return (
    <Screen>
      <ProgressIndicator currentStep={5} totalSteps={8} />
      
      <ScreenHeader
        title={copy.optionalNote.title}
        subtitle={copy.optionalNote.subtitle}
      />
      
      <TextInput
        label=""
        value={note}
        onChange={(value) => updateData({ optional_note: value })}
        placeholder={copy.optionalNote.placeholder}
        multiline
        rows={6}
      />
      
      <div style={{ 
        marginTop: 'var(--spacing-lg)', 
        display: 'flex', 
        flexDirection: 'column', 
        gap: 'var(--spacing-sm)' 
      }}>
        <Button
          variant="primary"
          size="large"
          fullWidth
          onClick={handleContinue}
        >
          {copy.optionalNote.continueButton}
        </Button>
        
        <Button
          variant="ghost"
          size="medium"
          fullWidth
          onClick={handleSkip}
        >
          {copy.optionalNote.skipButton}
        </Button>
      </div>
    </Screen>
  );
};
